import React from 'react'

export const EditSvg = ({ color }) => {
    return (
        <svg className="svg-icon" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="22" height="22" rx="3" stroke={color} stroke-width="2"/>
            <path d="M6.75 5.25C5.9175 5.25 5.25 5.9175 5.25 6.75V17.25C5.25 17.6478 5.40804 18.0294 5.68934 18.3107C5.97064 18.592 6.35218 18.75 6.75 18.75H17.25C17.6478 18.75 18.0294 18.592 18.3107 18.3107C18.592 18.0294 18.75 17.6478 18.75 17.25V12H17.25V17.25H6.75V6.75H12V5.25H6.75ZM16.335 6C16.2 6.00114 16.0708 6.05497 15.975 6.15L15.06 7.0575L16.935 8.9325L17.85 8.025C18.045 7.83 18.045 7.5 17.85 7.3125L16.6875 6.15C16.59 6.0525 16.4625 6 16.335 6ZM14.5275 7.59L9 13.125V15H10.875L16.4025 9.465L14.5275 7.59V7.59Z" fill={color}/>
        </svg>
    )
}